var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#668598",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.09375C10.2435 1.09375 12.9062 3.7208 12.9062 7C12.9062 10.2619 10.2646 12.9062 7 12.9062C3.73942 12.9062 1.09375 10.2659 1.09375 7C1.09375 3.74054 3.73521 1.09375 7 1.09375ZM7 0.21875C3.25508 0.21875 0.21875 3.25618 0.21875 7C0.21875 10.746 3.25508 13.7812 7 13.7812C10.7449 13.7812 13.7812 10.746 13.7812 7C13.7812 3.25618 10.7449 0.21875 7 0.21875ZM6.01562 9.625H6.34375V6.34375H6.01562C5.83442 6.34375 5.6875 6.19683 5.6875 6.01562V5.79688C5.6875 5.61567 5.83442 5.46875 6.01562 5.46875H7.32812C7.50933 5.46875 7.65625 5.61567 7.65625 5.79688V9.625H7.98438C8.16558 9.625 8.3125 9.77192 8.3125 9.95312V10.1719C8.3125 10.3531 8.16558 10.5 7.98438 10.5H6.01562C5.83442 10.5 5.6875 10.3531 5.6875 10.1719V9.95312C5.6875 9.77192 5.83442 9.625 6.01562 9.625ZM7 3.0625C6.51675 3.0625 6.125 3.45425 6.125 3.9375C6.125 4.42075 6.51675 4.8125 7 4.8125C7.48325 4.8125 7.875 4.42075 7.875 3.9375C7.875 3.45425 7.48325 3.0625 7 3.0625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.a4e7949dd3be24b1b38ac31a3b6c89ff.svg";
export { ForwardRef as ReactComponent };